import Marquee from "react-fast-marquee";

const ITEMS = [
  "7 ELECTRIC ADVICE",
  "LOS ANGELES, CA",
  "LICENSE #886996",
  "40+ YEARS OF EXPERTISE",
  "INDEPENDENT EXPERT ADVICE",
  "LUTRON PRO CERTIFIED",
];

export const Ribbon = ({ direction = "left" }) => (
  <div data-testid="ribbon" className="border-y border-white/10 bg-ink-900 py-6">
    <Marquee speed={28} direction={direction} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <span key={i} className="mx-10 flex items-center gap-10 font-body text-xs font-medium uppercase tracking-[0.4em] text-white/45">
          {t}
          <span className="h-1 w-1 rounded-full bg-amber" />
        </span>
      ))}
    </Marquee>
  </div>
);
